'use client';

import React from 'react';
import { useSelector } from 'react-redux';

import Link from 'next/link';

import Icon2 from '@/components/elements/icon/icon2';
import PseudoSelectContacts from '@/components/elements/select/pseudo-select-contacts';
import { useTranslation } from '@/i18n/client';
import { selectIsLoggedIn, selectUserName } from '@/store/auth';
import { buildUrl } from '@/utils/navigation';
import { createHeaderTestId } from '@/utils/string-utils';

import { HeaderPopupKeys, HeaderProps } from './header.types';
import SwitcherLanguage from './switcher-language';

export default function HeaderDesktop(props: HeaderProps) {
    const { t: tCo } = useTranslation(props.lang, 'common');
    const { t: tAu } = useTranslation(props.lang, 'auth');

    const isLoggedIn = useSelector(selectIsLoggedIn);
    const userName = useSelector(selectUserName);

    return (
        <div className="hidden items-center gap-2.5 xl:flex">
            <PseudoSelectContacts title={tCo('footer.contacts.title')} country={props.country?.code} />
            <SwitcherLanguage lang={props.lang} />

            {isLoggedIn ? (
                <Link
                    href={buildUrl('user', { lang: props.lang })}
                    data-testid={createHeaderTestId({ name: 'user-cabinet-link' })}
                >
                    <div className="ml-4 flex items-center justify-between gap-1.5 text-sm">
                        {userName && (
                            <div className="h-6 w-6 rounded-full bg-accent text-center">
                                <span className="text m-auto block text-base capitalize text-white">
                                    {userName.slice(0, 1) || ' '}
                                </span>
                            </div>
                        )}
                        <span>{tAu('buttons.profile')}</span>
                    </div>
                </Link>
            ) : (
                <button
                    className="ml-4 flex justify-between gap-1.5 text-sm"
                    onClick={() =>
                        props.isVisible.auth ? props.onClose(HeaderPopupKeys.auth) : props.onOpen(HeaderPopupKeys.auth)
                    }
                    aria-label={tCo('navigation.menu')}
                    data-testid={createHeaderTestId({ name: 'auth-btn' })}
                >
                    <span>{tAu('buttons.loginShort')}</span>
                    <Icon2
                        name="phi-caret-down-16"
                        iconClass={`h-5 w-5 transition-transform ${props.isVisible.auth ? '-scale-y-100' : ''}`}
                    />
                </button>
            )}
        </div>
    );
}
